import React, { useEffect, useState } from "react"
import { useInView } from "react-intersection-observer"
import { motion, useAnimation } from "framer-motion"
import styled from "styled-components"
import Wave from "../components/Wave"
import Div100vh from "react-div-100vh"
import {Link} from "gatsby"


const WaveBottom = styled.div`
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  right: 0;
`

const VideoHero = props => {
  const controls = useAnimation()
  const [ref, inView] = useInView({
    threshold: 0.4,
  })

  useEffect(() => {
    if (inView) {
      controls.start("visible")
    }
  }, [controls, inView])

  const group = {
    hidden: {
      opacity: 0,
      y: 50,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        staggerChildren: 0.2,
        delayChildren: .6,
      },
    },
  }

  const child = {
    hidden: {
      opacity: 0,
      y: 50,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
      },
    },
  }

  return (
    // <Div100vh>
      <div className="video-hero">
        {/* <WaveBottom><Wave /></WaveBottom> */}
        <video
          loop
          autoPlay
          muted="true"
          playsInline="true"
          disablePictureInPicture="true"
          className="video-hero__bg-video"
        >
          <source src={props.video} type="video/mp4" />
        </video>

        <div className="video-hero__content">
          <motion.div
            animate="visible"
            transition={{
              type: "tween",
              ease: "easeIn",
            }}
            initial="hidden"
            variants={group}
          >
            <motion.div
              transition={{
                type: "tween",
                ease: "easeIn",
              }}
              className="video-title"
              variants={child}
            >
              <h1 className="video-hero__content-title">{props.title}</h1>
            </motion.div>
            {/* <motion.div
              transition={{
                type: "tween",
                ease: "easeIn",
              }}
              className="video-text"
              variants={child}
            >
              <p className="video-hero__content-text big-subtitle">{props.text}</p>
            </motion.div> */}
          <div className="video-hero__cta">
            <motion.div
              transition={{
                type: "tween",
                ease: "easeIn",
              }}
              className="video-text"
              variants={child}
            >
              <Link to="/about" className="button-primary">
                Learn more
              </Link>
            </motion.div>
            <motion.div
              transition={{
                type: "tween",
                ease: "easeIn",
              }}
              className="video-text"
              variants={child}
            >
              <Link to="/donate" className="button-primary">
                Donate
              </Link>
            </motion.div>
          </div>
          </motion.div>
        </div>
      </div>
    // </Div100vh>
  )
}

export default VideoHero
